import script from "./TicketsHistoryWrapper.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsHistoryWrapper.vue?vue&type=script&setup=true&lang=js"

import "./TicketsHistoryWrapper.vue?vue&type=style&index=0&id=6dbd6f3c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6dbd6f3c"]])

export default __exports__